// extracted by mini-css-extract-plugin
export var text = "_am-0";